export function mapSourceToTarget<T extends object, U extends object>(
    source: U,
    target: new () => T
): T {
    const targetInstance = new target();
    const result = {} as T;

    (Object.keys(targetInstance) as Array<keyof T>).forEach((key) => {
        if (source[key as unknown as unknown as keyof U] !== undefined) {
            result[key] = source[key as unknown as keyof U] as unknown as T[keyof T];
        }
    });

    return result;
}

export function mapListSourceToTarget<T extends object, U extends object>(
    sourceList: U[]
): T[] {
    return sourceList.map((source) => {
        const result = {} as T;

        (Object.keys(source) as Array<keyof T>).forEach((key) => {
            if (source[key as unknown as keyof U] !== undefined) {
                result[key] = source[key as unknown as keyof U] as unknown as T[keyof T];
            }
        });

        return result;
    });
}

export function convertTo12HourFormat(time: string | null): string {
    if (!time) return ''; // Retorna uma string vazia se o valor for nulo ou vazio
    const [hour, minute] = time.split(':');
    const hourInt = parseInt(hour, 10);
    const period = hourInt >= 12 ? 'PM' : 'AM';
    const formattedHour = hourInt % 12 || 12; // Converte 0 para 12 no formato 12 horas
    return `${formattedHour}:${minute} ${period}`;
}
